import theme from '../index';

export interface MuiComponentSettings {
	[key: string]: string | number | object;
}

export const MuiTable: MuiComponentSettings = {
	styleOverrides: {
		root: () => ({
			'& .MuiTableHead-root': {
				'& .MuiTableRow-root': {
					'.MuiTableCell-head': {
						fontSize: '12px',
						lineHeight: '20px',
						fontWeight: '400',
						background: theme.palette.neutral100,
						color: theme.palette.neutral500,
						padding: '4px 8px',
						borderBottom: 'none',

						'&:first-of-type': {
							borderRadius: '8px 0 0 8px',
							paddingLeft: '16px',
						},

						'&:last-child': {
							borderRadius: '0 8px 8px 0',
							paddingRight: '16px',
						},
					},
				},

				'.MuiTableCell-body': {
					borderBottom: 'none',
					padding: '8px 16px',
				},

				'.MuiTableSortLabel-icon': {
					marginRight: 0,
				},
			},

			'& .MuiTableBody-root': {
				'& .MuiTableRow-root': {
					'.MuiTableCell-body': {
						padding: '0 8px',

						'&:first-of-type': {
							paddingLeft: '16px',
						},

						'&:last-child': {
							paddingRight: '16px',
						},

						'& .MuiTypography-root': {
							color: 'var(--neutral-900)',
							fontSize: '14px',
							fontWeight: '400',
							lineHeight: '20px',
						},
					},
				},

				'.MuiTableCell-body': {
					borderBottom: 'none',
				},
			},
		}),
	},
};
